import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ClipboardList, ExternalLink, Calendar, Briefcase, ChevronRight } from "lucide-react";

const ApplicationsList = () => {
  const applications = useSelector((state) => state.applications);

  return (
    <div className="max-w-5xl mx-auto px-6 py-12">
      <div className="flex justify-between items-center mb-10">
        <div>
          <h1 className="text-3xl font-bold text-slate-900">My Applications</h1>
          <p className="text-slate-500">Track and manage your job applications</p>
        </div>
        <div className="bg-blue-50 text-blue-600 px-4 py-2 rounded-xl text-sm font-bold border border-blue-100">
          {applications.length} {applications.length === 1 ? 'Application' : 'Applications'}
        </div>
      </div>

      {applications.length === 0 ? (
        <div className="text-center py-20 glass-card rounded-3xl border border-white/40">
          <div className="bg-slate-50 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
            <ClipboardList className="text-slate-300" size={32} />
          </div>
          <h2 className="text-xl font-bold text-slate-800">No applications yet</h2>
          <p className="text-slate-500 mb-8">You haven't applied to any jobs yet. Start exploring now!</p>
          <Link to="/" className="btn-primary inline-flex items-center gap-2">
            Explore Jobs
            <ChevronRight size={18} />
          </Link>
        </div>
      ) : (
        <div className="grid gap-6">
          {applications.map((app) => (
            <Link
              key={app.id}
              to={`/applications/${app.id}`}
              className="glass-card rounded-2xl p-4 sm:p-6 flex flex-col md:flex-row md:items-center justify-between gap-6 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 group border border-white/40"
            >
              <div className="flex items-center gap-6">
                <div className="bg-slate-900 p-4 rounded-2xl group-hover:bg-blue-600 transition-colors">
                  <Briefcase className="text-white w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-slate-900 group-hover:text-blue-600 transition-colors">
                    Job ID: {app.jobId}
                  </h3>
                  <div className="flex flex-wrap gap-4 mt-1">
                    <span className="flex items-center gap-1.5 text-sm text-slate-500">
                      <Calendar size={14} />
                      Applied on {new Date(app.id).toLocaleDateString()}
                    </span>
                    <span className="bg-green-50 text-green-600 text-[10px] font-bold px-2 py-0.5 rounded-full border border-green-100 uppercase tracking-wider">
                      Submitted
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="hidden md:flex flex-col items-end mr-4">
                  <p className="text-xs text-slate-400">Status</p>
                  <p className="text-sm font-bold text-slate-700">Under Review</p>
                </div>
                <div className="btn-secondary !p-3 rounded-xl group-hover:bg-slate-900 group-hover:text-white transition-all">
                  <ExternalLink size={20} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ApplicationsList;

